import { Progress } from 'antd';
import React from 'react';

import { VARIANT_CONFIG, getVariantFromScore } from '../../scoreUtils';

import styles from './ScoreTag.module.scss';

type ScoreTagProps = {
  score?: number;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
};

export const ScoreTagComponent: React.FC<ScoreTagProps> = ({
  score,
  onClick,
}) => {
  const variant = getVariantFromScore(score);
  const config = VARIANT_CONFIG[variant];
  const percentage = score !== undefined ? Math.round(score) : 0;

  return (
    <div
      className={styles.scoreTag}
      style={{
        backgroundColor: config.backgroundColor,
        borderColor: config.borderColor,
      }}
      onClick={onClick}
    >
      <div className={styles.scoreContent}>
        <span className={styles.scoreNumber}>
          {score !== undefined ? Math.round(score) : '-'}
        </span>
        <span className={styles.scoreMax}>/100</span>
      </div>
      <div className={styles.progressContainer}>
        <Progress
          type="circle"
          percent={percentage}
          width={20}
          strokeColor={config.strokeColor}
          strokeLinecap="square"
          strokeWidth={20}
          trailColor="#00000014"
          format={() => null}
        />
      </div>
    </div>
  );
};
